import { useCallback, useRef, useState } from 'react'

/** Copy text to clipboard with a brief success state. */
export function useCopy(options: { timeout?: number } = {}) {
  const { timeout = 800 } = options
  const [notifying, setNotifying] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  const copy = useCallback(
    async (value: string) => {
      if (timer.current) clearTimeout(timer.current)
      try {
        if (!navigator.clipboard) throw new Error('Clipboard API not supported')
        await navigator.clipboard.writeText(value)
        setNotifying(true)
        timer.current = setTimeout(() => setNotifying(false), timeout)
        return true
      } catch (error) {
        console.error('useCopy: Failed to copy text:', error)
        return false
      }
    },
    [timeout],
  )

  return { copy, notifying }
}
